<template>
  <div>
    <NavBar />
    <div id="app" class="pb-5">
      <router-view />
    </div>
    <bottomNavBar v-if="showBottomNavBar"/>
  </div>
</template>

<script>
import NavBar from '../src/components/NavBar.vue';
import bottomNavBar from '../src/components/bottomNavBar.vue';
import jwt from 'jsonwebtoken'
export default {
  name: 'app',
  components: {
    NavBar,
    bottomNavBar
  },
    computed: {
      showBottomNavBar() {
        return this.$route.name !== 'Servizio'
      }
    },
  created: async function () {
    this.$store.commit('GET_USER_DATA')
    if(this.$route.query.error){
      alert(this.$route.query.error)
    }
    if (this.$route.query.user) {
      console.log('mounted user docente:', this.$route.query.user)
      const key = this.$route.query.key;
      if (key) {window.OpenReplay.setUserID(key);}
      this.$store.commit('RESET_USER_DATA')
      let user = jwt.decode(this.$route.query.user)
      console.log('user', user)
      let connection = {
        username: user.username,
        userdata: user.token,
      }
      this.$store.commit('SET_CONNECTION', connection)
      console.log('connection', this.$store.state.connection)
      if (!this.$store.state.connection.userdata) {
        this.showerror = true;
        this.$router.push({name: 'Login'});
        return
      } else if (connection.userdata === 'Bloccato') {
        this.$store.state.blocked = true
        this.showblocked = true;
        this.$router.push({name: 'Login'});
        return
      }
      this.$store.commit('SET_CONNECTION_READY', true)

    }
  }
}
</script>

<style>
/* @import url('https://fonts.googleapis.com/css?family=Montserrat:thin,extra-light,light,100,200,300,400,500,600,700,800'); */
:root {
  /* --font: 'Montserrat'; */
}

input {
  height: 5vh;
  width: 100%;
  border-radius: 10px;
  padding-left: 5%;
  border: 1px solid grey;
}

/* button{ border-radius: 10px; } */
</style>